package com.sddamico.swigmore.components.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.remember
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.core.Card
import com.sddamico.swigmore.ds.core.CardVariant
import com.sddamico.swigmore.ds.core.Eyebrow
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.forms.Button
import com.sddamico.swigmore.ds.forms.ButtonStyle
import com.sddamico.swigmore.ds.forms.ButtonVariant
import com.sddamico.swigmore.ds.forms.SelectField
import com.sddamico.swigmore.ds.typeDisplay
import com.sddamico.swigmore.ds.typeMono
import com.sddamico.swigmore.models.PollRules
import com.sddamico.swigmore.models.PollTeamDto
import com.sddamico.swigmore.util.rememberAction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text


/**
 * The commissioner's ballot form for one owner: eight numbered pickers. A team picked in one slot
 * is greyed out in the others.
 */
@Composable
fun BallotEditor(
  title: String,
  voterName: String,
  teams: List<PollTeamDto>,
  initial: List<String>,
  save: suspend (List<String>) -> Unit,
  onCancel: () -> Unit,
) {
  val request = rememberAction()
  val picks = remember(voterName, initial) {
    mutableStateListOf<String?>().apply { addAll(List(PollRules.BALLOT_SIZE) { initial.getOrNull(it) }) }
  }
  val options = remember(teams) {
    teams.sortedBy { it.name.lowercase() }.map { team -> team.id to (team.record?.let { "${team.name} ($it)" } ?: team.name) }
  }
  Card(variant = CardVariant.Ticket, padding = "18px", modifier = Modifier.css("margin-bottom" to "16px")) {
    Eyebrow(title, color = SwColor.inkSecondary, size = "10px")
    Div(attrs = Modifier.typeDisplay("24px", "1.1").css("margin" to "8px 0 14px").toAttrs()) { Text(voterName) }
    picks.forEachIndexed { index, pick ->
      Div(
        attrs = Modifier.css("display" to "grid", "grid-template-columns" to "32px minmax(0,1fr)", "gap" to "10px",
          "align-items" to "center", "margin-top" to "6px").toAttrs()
      ) {
        Div(attrs = Modifier.typeDisplay("22px").css("text-align" to "center").toAttrs()) { Text("${index + 1}") }
        SelectField(pick, { picks[index] = it }, options, placeholder = "Pick a team",
          label = "Ballot position ${index + 1}", unavailable = picks.filterNotNull().toSet())
      }
    }
    request.error?.let {
      Div(attrs = Modifier.typeMono("11px").css("margin-top" to "12px").toAttrs()) { Text(it) }
    }
    Div(attrs = Modifier.css("display" to "flex", "gap" to "8px", "margin-top" to "14px", "flex-wrap" to "wrap").toAttrs()) {
      val filled = picks.filterNotNull()
      Button(
        if (filled.size < PollRules.BALLOT_SIZE) "Fill ${PollRules.BALLOT_SIZE - filled.size} more" else "Save ballot",
        variant = ButtonVariant.Field, style = ButtonStyle.Caps,
        disabled = request.busy || filled.size < PollRules.BALLOT_SIZE,
        onClick = {
          request.run { save(filled) }
        },
      )
      Button("Cancel", variant = ButtonVariant.Ghost, style = ButtonStyle.Caps, disabled = request.busy, onClick = onCancel)
    }
  }
}
